export default __webpack_public_path__ + "assets/icon-give.4f8ba6c3.webp";